import { render } from "./Medicaid.vue?vue&type=template&id=ef432f5e&ts=true"
import script from "./Medicaid.ts?vue&type=script&lang=ts&external"
export * from "./Medicaid.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__